import { type FC } from 'react';
import { type Descendant } from 'slate';

import Modal from '@/components/Modal';
import ConversationThreadPage from '@/lib/ConversationThreadPage';
import type * as ApiModels from '@/typings/api-models';

import s from './ConversationThreadModal.module.scss';

type Props = {
  onClose: () => void;
  onReply: () => void;
  conversationSid: string;
  messageId: string;
  editMessageFn?: (data: {
    id: string;
    text?: { children: Descendant[] }[];
    medias?: { id: string }[];
    handbooks?: { id: string }[];
    attachments?: ApiModels.CreateMessageAttachment[];
  }) => Promise<void>;
};

const ConversationThreadModal: FC<Props> = ({ onClose, onReply, conversationSid, messageId, editMessageFn }) => (
  <Modal isNarrow isRightDrawer title='Thread' onClose={onClose}>
    <div className={s.modal} data-testid='chat.thread'>
      <ConversationThreadPage
        conversationSid={conversationSid}
        onSendReply={onReply}
        messageId={messageId}
        editMessageFn={editMessageFn}
        onCloseThread={onClose}
      />
    </div>
  </Modal>
);

export default ConversationThreadModal;
